// extracted by mini-css-extract-plugin
module.exports = {"search-form":"P_dR flex-grow-1 form-group mb-0"};